import apiService from './api';

const medicalDossierService = {
  /**
   * Dossier médical consolidé (toutes filières, ordonnances, infirmerie, accueil, RDV).
   */
  async getMemberDossier(memberId, opts = {}) {
    const q = new URLSearchParams();
    if (opts.consultLimit != null) q.set('consult_limit', String(opts.consultLimit));
    if (opts.visitLimit != null) q.set('visit_limit', String(opts.visitLimit));
    if (opts.rxLimit != null) q.set('rx_limit', String(opts.rxLimit));
    if (opts.rdvLimit != null) q.set('rdv_limit', String(opts.rdvLimit));
    const qs = q.toString();
    const path = `/medical-dossier/members/${encodeURIComponent(String(memberId))}${qs ? `?${qs}` : ''}`;
    return apiService.get(path);
  }
};

export default medicalDossierService;
